import {
  FEEDBACK_FETCH_REQUEST, FEEDBACK_FETCH_SUCCESS, FEEDBACK_FETCH_FAILURE,
  FEEDBACK_CREATE_REQUEST, FEEDBACK_CREATE_SUCCESS, FEEDBACK_CREATE_FAILURE,
  FEEDBACK_UPDATE_REQUEST, FEEDBACK_UPDATE_SUCCESS, FEEDBACK_UPDATE_FAILURE,
  FEEDBACK_DELETE_REQUEST, FEEDBACK_DELETE_SUCCESS, FEEDBACK_DELETE_FAILURE,
  FEEDBACK_RESET,
  MY_FEEDBACK_FETCH_REQUEST, MY_FEEDBACK_FETCH_SUCCESS, MY_FEEDBACK_FETCH_FAILURE
} from "./FeedbackTypes";

const initialState = {
  feedback: [],
  loading: false,
  error: null,
  createLoading: false,
  createSuccess: false,
  createError: null,
  updateLoading: false,
  updateSuccess: false,
  updateError: null,
  deleteLoading: false,
  deleteSuccess: false,
  deleteError: null,
  myFeedback: [],
  myFeedbackLoading: false,
  myFeedbackError: null
};

export const feedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch
    case FEEDBACK_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case FEEDBACK_FETCH_SUCCESS:
      return { ...state, loading: false, feedback: action.payload, error: null };
    case FEEDBACK_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Create
    case FEEDBACK_CREATE_REQUEST:
      return { ...state, createLoading: true, createSuccess: false, createError: null };
    case FEEDBACK_CREATE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createSuccess: true,
        createError: null,
        feedback: [action.payload, ...state.feedback]
      };
    case FEEDBACK_CREATE_FAILURE:
      return { ...state, createLoading: false, createSuccess: false, createError: action.payload };

    // Update
    case FEEDBACK_UPDATE_REQUEST:
      return { ...state, updateLoading: true, updateSuccess: false, updateError: null };
    case FEEDBACK_UPDATE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: true,
        updateError: null,
        feedback: state.feedback.map(item =>
          item.feedbackId === action.payload.feedbackId
            ? { ...item, ...action.payload }
            : item
        )
      };
    case FEEDBACK_UPDATE_FAILURE:
      return { ...state, updateLoading: false, updateSuccess: false, updateError: action.payload };

    // Delete
    case FEEDBACK_DELETE_REQUEST:
      return { ...state, deleteLoading: true, deleteSuccess: false, deleteError: null };
    case FEEDBACK_DELETE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteSuccess: true,
        deleteError: null,
        feedback: state.feedback.filter(item => item.feedbackId !== action.payload)
      };
    case FEEDBACK_DELETE_FAILURE:
      return { ...state, deleteLoading: false, deleteSuccess: false, deleteError: action.payload };

    // My Feedback (student view)
    case MY_FEEDBACK_FETCH_REQUEST:
      return { ...state, myFeedbackLoading: true, myFeedbackError: null };
    case MY_FEEDBACK_FETCH_SUCCESS:
      return { ...state, myFeedbackLoading: false, myFeedback: action.payload, myFeedbackError: null };
    case MY_FEEDBACK_FETCH_FAILURE:
      return { ...state, myFeedbackLoading: false, myFeedbackError: action.payload };

    // Reset
    case FEEDBACK_RESET:
      return initialState;

    default:
      return state;
  }
};
